export default class Record {
    constructor(arrangeTime, goods_name, phone, status) {
        this.arrangeTime = arrangeTime;
        this.goods_name = goods_name;
        this.phone = phone;
        this.status = status;
    }
}


// WEBPACK FOOTER //
// ./src/models/Record.js